//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICollectionSourcesDto } from '@apis/collections/ICollectionSourcesDto';
import { ICuralateStore } from '@models/AppState';

const oldInstagramSource = (state: ICuralateStore) => {
  const assetFeedsStream = state.streams.streamsDrawer.selectedStream;
  const businessUsers = assetFeedsStream.sources.instagramBusinessUsers;
  const hasBusinessUsers = (businessUsers && businessUsers.length > 0);

  if (hasBusinessUsers) {
    const oldBusinessUserId = assetFeedsStream.sources.instagramBusinessUsers[0];
    const oldUsername = assetFeedsStream.sourcesMetadata.instagramBusinessUsers[oldBusinessUserId].username;

    return {
      instagramBusinessUsers: [oldBusinessUserId],
      businessUserMappings: {
        [oldBusinessUserId]: oldUsername,
      }
    };
  } else {
    return {};
  }
};

export const getOldInstagramSource = createSelector(
  oldInstagramSource,
  (source: ICollectionSourcesDto) => {
    return source;
  },
);

export default getOldInstagramSource;
